export default __webpack_public_path__ + "static/media/built-to-learn.0fd00858.webp";